module.exports = __webpack_public_path__ + "static/img/banner-01.57175d47.png";